import { render, staticRenderFns } from "./ContactPlusInfo.vue?vue&type=template&id=4f224e56&scoped=true&"
import script from "./ContactPlusInfo.vue?vue&type=script&lang=js&"
export * from "./ContactPlusInfo.vue?vue&type=script&lang=js&"
import style0 from "./ContactPlusInfo.vue?vue&type=style&index=0&id=4f224e56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f224e56",
  null
  
)

export default component.exports